import { Col, Row } from 'antd'
import Icon from 'app/components/UI-Elements/General/Icon'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import React from 'react'

import LoginLink from '../Component/LoginLink'

const EmailConfirmation: React.FC<PageProps> = ({ route }) => {
  const { tRoute } = useTranslation({ scope: route.key })

  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <p className="text-primary text-center">{tRoute({ id: 'description' })}</p>
      </Col>
      <Col span={24} className="text-center">
        <Icon type="mail" />
      </Col>
      <Col span={24} className="text-center">
        <LoginLink />
      </Col>
    </Row>
  )
}

export default EmailConfirmation
